import { FormFieldTypes } from "../../../../../components/finalForms/libs/data/formFieldType";

const initState = {
    sPurchaseOrder:''
};

export const OutstandingSearchFilter = {
  name: "Outstanding Invoice Filter",
  initialState: initState,
  section: [
    {
      sectionId: "basicDetailSection",
      title: "Outstanding Invoice Filter Section",
      row: {},
      style: {
        sectionStyle: "col-lg-12 col-md-12",
      },
      wrapperTemplate: <div className="row"></div>, // Wrapper HTML or Component
      rowGroup: [
        {
          groupLabel: "Contact Information", // Group for contact fields
          style: {
            groupStyle: "col-lg-12 col-md-12 mb-3",
          },
          groupWrapper: <div className="form-card row ml-1 mr-2"></div>, // Wrapper HTML or Component
          fields: [
            {
              id: "sPurchaseOrder",
              label: "Work/Purchase Order :",
              Field_Name: "sPurchaseOrder",
              fieldType: FormFieldTypes.INPUT,
              dataField: "sPurchaseOrder",
              fieldSetting: {
                placeholder: "Enter Work/Purchase Order",
              },
              style: { containerCss: "invoice-search-filter col-xl-4 col-lg-4 col-md-5 col-12" },
            },
            
          ],
        },
        
      ],
    }
  ]
}